
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/base/Card';

interface QuickAction {
  id: string;
  title: string;
  icon: string;
  color: string;
  bgColor: string;
  path: string;
}

const quickActions: QuickAction[] = [
  {
    id: 'cards',
    title: 'بطاقاتي',
    icon: 'ri-bank-card-fill',
    color: '#007AFF',
    bgColor: '#007AFF/10',
    path: '/cards'
  },
  {
    id: 'booking',
    title: 'حجز موعد',
    icon: 'ri-calendar-check-fill',
    color: '#34C759',
    bgColor: '#34C759/10',
    path: '/booking'
  },
  {
    id: 'tracking',
    title: 'متابعة الحالات',
    icon: 'ri-file-list-3-fill',
    color: '#F9A826',
    bgColor: '#F9A826/10',
    path: '/tracking'
  },
  {
    id: 'offers',
    title: 'العروض',
    icon: 'ri-gift-fill',
    color: '#FF3B30',
    bgColor: '#FF3B30/10',
    path: '/offers'
  }
];

export default function QuickActions() {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-2 gap-4">
      {quickActions.map((action) => (
        <Card
          key={action.id}
          padding="md"
          onClick={() => navigate(action.path)}
          className="text-center cursor-pointer hover:shadow-md transition-shadow"
        >
          <div 
            className="w-16 h-16 rounded-2xl mx-auto mb-3 flex items-center justify-center"
            style={{ backgroundColor: action.bgColor }}
          >
            <i 
              className={`${action.icon} text-2xl`}
              style={{ color: action.color }}
            ></i>
          </div>
          <h3 className="font-bold text-[#333333] text-sm">{action.title}</h3>
        </Card>
      ))}
    </div>
  );
}
